import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconRedo = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M17.0977 6.90137V10.2998H13.6992"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9999 17.0967C11.0653 17.0972 10.1484 16.8408 9.34963 16.3554C8.55086 15.87 7.90093 15.1743 7.47089 14.3444C7.04084 13.5145 6.84725 12.5824 6.91126 11.6499C6.97528 10.7174 7.29445 9.82044 7.83387 9.05711C8.37329 8.29378 9.11219 7.69346 9.9698 7.32176C10.8274 6.95007 11.7707 6.82133 12.6966 6.9496C13.6224 7.07788 14.4952 7.45824 15.2194 8.0491C15.9436 8.63996 16.4915 9.41857 16.8031 10.2998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconRedo.displayName = 'IconRedo';
